import React, {useContext} from 'react'; 
import UserContext  from '../../context/Globales/UserContext';

import {makeStyles, TableContainer, Table, TableCell, TableRow,TableHead,TableBody,Button, Modal,Fade,Backdrop, Typography} from '@material-ui/core';
import {v4 as uuid } from 'uuid';
import swal from  'sweetalert';
import TblExtractoSociedad from './TblExtractoSociedad';
import ViewInformeModal from '../ConsultaInformeModal/ViewInformeModal';
import Loading from '../modales/Loading';
import IcpdfDetallesSocios from '../pdf/IC/IcpdfDetalleSocios';
import { mensajeglobales } from '../../helpers/Confi';
import { DecodificanString } from '../../helpers/Codifican';

    const useStyles = makeStyles((theme) => ({
      tituloTable: {
       backgroundColor: '#e6e6e6', 
       minWidth: 200,
       color: 'black',
       textAlign: 'center',
       padding: '10px',
       fontWeight: '250',
       fontSize : '16px'
    },  
        tituloTable2: {

          backgroundColor: theme.palette.fondotitulos.main,
          // backgroundImage : `url(${FondoImagenes})`,
  
          minWidth: 200,
          color: '#171717',
          textAlign: 'center',
          padding: '16px',
          fontWeight: '250',
          fontSize: '35px'
      },
       
        TituloIdentificacion: {
    
           backgroundColor: theme.palette.primary.main, 
           minWidth: 200,
           color: 'white',
           textAlign: 'center',
           padding: '15px',
           fontWeight: '250',
           fontSize : '18px',
           height: 'auto',
           alignContent: 'center',               
        },
        modaldetalle: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          overflow:'scroll',
           height:'100%',
        },
      paperdetalle: {
          backgroundColor: theme.palette.background.paper,
          border: '2px solid #000',
          boxShadow: theme.shadows[5],
          padding: theme.spacing(2, 4, 3),
          width: '50%',
          height: '50%',
          overflow:'scroll',
        },

        modalExtracto: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            overflow:'scroll',
             height:'100%',
          },
        paperExtracto: {
            backgroundColor: theme.palette.background.paper,
            border: '2px solid #000',
            boxShadow: theme.shadows[5],
            padding: theme.spacing(2, 4, 3),
            width: '50%',
            height: '50%',
            overflow:'scroll',
          },


          paperInforme: {
            backgroundColor: theme.palette.background.paper,
            border: '2px solid #000',
            boxShadow: theme.shadows[5],
            padding: theme.spacing(2, 4, 3),
            width: '95%',
            height: '90vh',
            overflow:'scroll',
          },
  
          modalInforme: {
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              overflow:'scroll',
               height:'100%',
            },

            modalPdf: {
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
            },
            paperPdf: {
              backgroundColor: theme.palette.background.paper,
              border: '2px solid #000',
              boxShadow: theme.shadows[5],
              padding: theme.spacing(2, 4, 3),
              width: '50%',
            },
        FondoTable :{
       
            backgroundColor: theme.palette.greyFondo.main
        },

        containerTable: {
            maxHeight: 440,
            maxWidth: '100%'
          },
          mousePointer : {cursor: 'pointer'},
    }));

const TblDetalleSocios = (dataSocios) => {
  const classes = useStyles();

  const DatosTipoContrato = DecodificanString(localStorage.getItem("tipCont"))
 
  const [datoSOC] = React.useState(dataSocios)
  const [OpenModalExtracto, setOpenModalExtracto] = React.useState(false);
  const [OpenModalICOMERCIAL, setOpenModalICOMERCIAL] = React.useState(false);
  const [OpenLoadingICSocios, setOpenLoadingICSocios] = React.useState(false);
  const [OpenModalpdfSocio, setOpenModalpdfSocio] = React.useState(false);
  

  const userContext = useContext(UserContext);
  const { DataContatoInfoCom, datoIC, DatadetalleExtracto, DataTipoContrato } = useContext(UserContext);

  const MSG = mensajeglobales(); // mensaje globales;

    const handleClickPdf=()=>{

        setOpenModalpdfSocio(!OpenModalpdfSocio)

    };


    const handleClickSocieExtracto =()=>{
      setOpenModalExtracto(false); // cerrar modal
    
  };

  const MostrarExtracto = (Extracto)=>{

    if (DatadetalleExtracto == null || DatadetalleExtracto === 'ERROR CONSULTA EXTRACTO'){

      userContext.getDetalleExtracto(Extracto, datoIC.ID);
      // handleClickSocieExtracto();
      setOpenModalExtracto(true);

    }else{
      
      setOpenModalExtracto(true);
    }
     
  }; 

  const handleClickInformeModal = ()=>{
      setOpenModalICOMERCIAL(!OpenModalICOMERCIAL);
  };

  const ConsultSociosInformeComercial=(Rut)=>{
    setOpenLoadingICSocios(true);

    const id = DecodificanString(JSON.parse(localStorage.getItem("id")));
    const login = DecodificanString(JSON.parse(localStorage.getItem("login")));
    const clientId = DecodificanString(JSON.parse(localStorage.getItem("clientId")));



    userContext.getContractInfoCom(id, login, clientId, DatosTipoContrato.Id);//obten los datos que solicite en el formulario 

    //validacion


    if (DataContatoInfoCom.Exist || DecodificanString(JSON.parse(localStorage.getItem('ContratoInfoCom')))) {

    setTimeout(() => {
      

    userContext.getInfoComercialModal(Rut);
    handleClickInformeModal();
    setOpenLoadingICSocios(false);

  


   }, 3000);
   
  } else {
    
    setOpenLoadingICSocios(false);

    swal({
      title: "Atención",
      text: MSG.MSG_NO_TIENE_PRODUCTO_ASOCIADO,
      icon: "warning",
      button: "OK",
    });
  }
}


    return (
        <>
{OpenLoadingICSocios ? <Loading /> : '' }


      

    {/*MODAL PDF INFORME COMER*/}

    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modalPdf}
      open={OpenModalpdfSocio}
      onClose={handleClickPdf}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 2000,
    }}>
    <Fade in={OpenModalpdfSocio}>
    
      <div className={classes.paperPdf}>


        <IcpdfDetallesSocios datoS={datoSOC}   />      

 
      
      </div>
 
    </Fade> 
    </Modal>


{/*Extracto */}
   <Modal
     aria-labelledby="transition-modal-title"
     aria-describedby="transition-modal-description"
     className={classes.modaldetalle}
     open={OpenModalExtracto}
     onClose={handleClickSocieExtracto}
     closeAfterTransition
     BackdropComponent={Backdrop}
     BackdropProps={{
       timeout: 500,
     }}
   >
     <Fade in={OpenModalExtracto}>
       <div className={classes.paperdetalle}>

     
       <Typography variant="h5" align="right"  onClick={handleClickSocieExtracto} className={classes.mousePointer} >X</Typography>
       
         <TblExtractoSociedad />

       </div>
     </Fade> 
   </Modal>


    {/*InformeComercial Modal */}


    <Modal
     aria-labelledby="transition-modal-title"
     aria-describedby="transition-modal-description"
     className={classes.modalInforme}
     open={OpenModalICOMERCIAL}
     onClose={handleClickInformeModal}
     closeAfterTransition
     BackdropComponent={Backdrop}
     BackdropProps={{
       timeout: 500,
     }}
   >
     <Fade in={OpenModalICOMERCIAL}>
       <div className={classes.paperInforme}>

     
       <Typography variant="h5" align="right"  onClick={handleClickInformeModal} className={classes.mousePointer} >X</Typography>
       
         <ViewInformeModal />

       </div>
     </Fade> 
   </Modal>
   

    
            <div className={classes.content}>

            {datoSOC && datoSOC.dataSocios!=null ? <div style={{alignContent:"center", textAlign : "center"}}><Button variant="contained" color="primary" onClick={handleClickPdf}>Descargar PDF</Button></div> : ''}

            <h1 style={{ position: '-webkit-sticky', position: 'sticky', textAlign: 'center'}}>{datoSOC.dataSocios.NombreRazonSocialPublicada}</h1>
            <TableContainer className={classes.containerTable}>
               <Table>
                  <TableBody >
                  
                    <TableRow key={uuid()} style={{backgroundColor : '#dedfe3'}}>
                    
                    <TableCell ><strong>Tipo Publicación:</strong></TableCell><TableCell>{datoSOC.dataSocios.TipoPublicacion}</TableCell>
                    <TableCell><strong>Fecha de Públicación:</strong></TableCell><TableCell>{datoSOC.dataSocios.FechaPublicacion}</TableCell>
                    
                    </TableRow>
                  </TableBody>
                  
                </Table>
                </TableContainer>

              { datoSOC && datoSOC.dataSocios.Detalles.map((dataS, iddataS )=>(
               <TableContainer className={classes.containerTable}>
               <Table size="small">
                  <TableBody key={iddataS}>

                    <TableRow>
                    <TableCell style={{backgroundColor : '#dedfe3'}} ><strong>Rut:</strong></TableCell><TableCell>{dataS.Rut}  - 
                    {dataS.Rut == null || dataS.Rut === '0-0' ? 
                     'Imposible en recatar este dato' :
                    <Button variant="outlined" color="primary" 
                     onClick={()=>{ConsultSociosInformeComercial(dataS.Rut)}}
                    >Informe Comercial  </Button>} </TableCell>
                    
                    </TableRow>
                    <TableRow>
                    <TableCell style={{backgroundColor : '#dedfe3'}}><strong>Fecha de Escritura:</strong></TableCell><TableCell>{dataS.FechaEscritura}</TableCell>
                    </TableRow>
                    <TableRow>
                    <TableCell style={{backgroundColor : '#dedfe3'}}><strong>Fecha de Constitución:</strong></TableCell><TableCell>{dataS.FechaDeConstitucion}</TableCell>
                    </TableRow>
                    <TableRow>
                    <TableCell style={{backgroundColor : '#dedfe3'}}><strong>Fecha de Constitución:</strong></TableCell><TableCell>{dataS.FechaDeConstitucion}</TableCell>
                    </TableRow>


                    <TableRow>
                    <TableCell style={{backgroundColor : '#dedfe3'}}><strong>Nombre de Fantasia:</strong></TableCell><TableCell>{dataS.NombreDeFantasia}</TableCell>
                    </TableRow>
                    <TableRow>
                    <TableCell style={{backgroundColor : '#dedfe3'}}><strong>Constituidad como:</strong></TableCell><TableCell>{dataS.ConstituidaComo}</TableCell>
                    </TableRow>
                    <TableRow>
                    <TableCell style={{backgroundColor : '#dedfe3'}}><strong>Fecha de Termino:</strong></TableCell><TableCell>{dataS.FechaDeTermino}</TableCell>
                    </TableRow>
                    <TableRow>
                    <TableCell style={{backgroundColor : '#dedfe3'}}><strong>Capital Suscrito (peso):</strong></TableCell><TableCell>{dataS.CapitalSuscrito}</TableCell>
                    </TableRow>
                    <TableRow>
                    <TableCell style={{backgroundColor : '#dedfe3'}}><strong>Capital Pagado (peso):</strong></TableCell><TableCell>{dataS.CapitalPagado}</TableCell>
                    </TableRow>
                    <TableRow>
                    <TableCell style={{backgroundColor : '#dedfe3'}}><strong>Acciones:</strong></TableCell><TableCell>{dataS.NumeroDeAcciones}</TableCell>
                    </TableRow>
                    <TableRow>
                    <TableCell style={{backgroundColor : '#dedfe3'}}><strong>Localidad Registro Comercio:</strong></TableCell><TableCell>{dataS.CiudadNotario}</TableCell>
                    </TableRow>
                    <TableRow>
                    <TableCell style={{backgroundColor : '#dedfe3'}}><strong>Extracto Público:</strong></TableCell><TableCell>{datoSOC.dataSocios.Extracto} - 
                    {dataS.Rut == null || dataS.Rut === '0-0' ? 
                    'Imposible en rescatar este parametro' : <Button variant="outlined" color="primary" onClick={()=>{MostrarExtracto(datoSOC.dataSocios.Extracto)}}>Ver Extracto</Button> }

                    </TableCell>
                    </TableRow>
                  </TableBody>
                  
                </Table>
                </TableContainer>
                
              ))}
      
        
      { datoSOC && datoSOC.dataSocios.Detalles[0].Socios!=null ? 

 

           <TableContainer className={classes.containerTable} hidden={datoSOC.dataSocios.Detalles[0].Socios==null || datoSOC.dataSocios.Detalles[0].Socios ==undefined ? true : false} >
        <h1 style={{ position: '-webkit-sticky', position: 'sticky', textAlign: 'center'}}>LISTADO DE SOCIOS</h1>
        <Table size="small">
            <TableHead>
              <TableRow>
                    
                  <TableCell style={{backgroundColor : '#dedfe3'}}><strong>Rut:</strong></TableCell>
                  <TableCell style={{backgroundColor : '#dedfe3'}}><strong>Nombre:</strong></TableCell> 
                  <TableCell style={{backgroundColor : '#dedfe3'}}><strong>Motivo:</strong></TableCell> 
                  <TableCell style={{backgroundColor : '#dedfe3'}}><strong>Aporte:</strong></TableCell> 
                  <TableCell style={{backgroundColor : '#dedfe3'}}><strong>Moneda:</strong></TableCell>
                  <TableCell style={{backgroundColor : '#dedfe3'}}><strong>Porcentaje:</strong></TableCell>  
               
              </TableRow>
            </TableHead>
       
            <TableBody  >
            {datoSOC.dataSocios.Detalles[0].Socios.map((SociosS, idsociosdetalle)=>(
              <TableRow key={idsociosdetalle}>
              <TableCell>{SociosS.Rut}  &nbsp;
              { SociosS.Rut == null || SociosS.Rut === '0-0' ? 
               '' :  <Button variant="outlined" color="primary" onClick={()=>{ConsultSociosInformeComercial(SociosS.Rut)}}
               > Informe Comercial </Button> }</TableCell>
              <TableCell>{SociosS.Nombre}</TableCell>
              <TableCell>{SociosS.MotivoPublicacion}</TableCell>
              <TableCell>{SociosS.Aporte}</TableCell>
              <TableCell>{SociosS.Moneda}</TableCell>
              <TableCell>{SociosS.Porcentaje} %</TableCell>
              </TableRow>
              ))}
            </TableBody>
        
        
              </Table>
              </TableContainer>
            : <h2>SIN INFORMACION DE SOCIOS</h2>

        }

          
            </div>
            
             

              
            

        
        </>
    )
}

export default TblDetalleSocios;
